import script from "./StructureChart.vue?vue&type=script&setup=true&lang=js"
export * from "./StructureChart.vue?vue&type=script&setup=true&lang=js"

import "./StructureChart.vue?vue&type=style&index=0&id=007db548&lang=scss"

const __exports__ = script;

export default __exports__